import React from 'react';
import {Button} from '@xpertdox_js/xdcomponents';
import {absCenter, clearfix, colors} from '@xpertdox_js/xdstyle';

const styles = {
  container: {
    marginTop: '12px'
  },
  trialContainer: {
    ...clearfix,
    position: 'relative',
    marginBottom: '10px',
    // border: '1px solid rgba(0,22,66,0.18)',
    boxShadow: '0 1px 2px rgba(0, 22, 66, 0.24)'
  },
  trialText: {
    float: 'left',
    lineHeight: '1.3rem',
    width: '80%',
    fontSize: '1.25rem',
    padding: '5px 0 5px 5px',
    // border: '1px solid rgba(0,0,0,0.18)',
    // borderRight: 0,
    background: '#fff',
  },
  trialBtn: {
    position: 'absolute',
    top: 0,bottom: 0,left: 'auto', right: 0,
    padding: 0,
    background: 'rgba(0,0,0,0.05)',
    // border: '1px solid rgba(0,0,0,0.18)',
    borderLeft: '1px solid rgba(0,22,66,0.18)',
    float: 'right',
    width: '20%',
    height: '100%',
    fill: 'rgba(0,0,0,0.32)',
  },
  trialBtnHov: {
    background: 'rgba(0,0,0,0.1)',
    fill: colors.error,
  },
  svg: {
    ...absCenter,
    display: 'block',
    width: '28px',
    height: '28px'
  }
}

const SelectedTrials = props => {
  return(
    <div style={styles.container}>
      {props.selectedTrials.map((trial, i) => {
        return(
          <div
            key={trial._id}
            style={i === props.selectedTrials.length - 1 ? {...styles.trialContainer, marginBottom: 0} : styles.trialContainer}
          >
            <div style={styles.trialText}>
              {trial._source.title1}
            </div>
            <Button
              styles={styles.trialBtn}
              hoverStyles={styles.trialBtnHov}
              onClick={props.removeTrial}
              clickParam={trial._id}
            >
              <svg style={styles.svg} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M278.6 256l68.2-68.2c6.2-6.2 6.2-16.4 0-22.6-6.2-6.2-16.4-6.2-22.6 0L256 233.4l-68.2-68.2c-6.2-6.2-16.4-6.2-22.6 0-3.1 3.1-4.7 7.2-4.7 11.3 0 4.1 1.6 8.2 4.7 11.3l68.2 68.2-68.2 68.2c-3.1 3.1-4.7 7.2-4.7 11.3 0 4.1 1.6 8.2 4.7 11.3 6.2 6.2 16.4 6.2 22.6 0l68.2-68.2 68.2 68.2c6.2 6.2 16.4 6.2 22.6 0 6.2-6.2 6.2-16.4 0-22.6L278.6 256z"/></svg>
            </Button>
          </div>
        )
      })
      }
    </div>
  )
}

export default SelectedTrials;
